import { insertRouteAfter } from 'utils/insertRouteAfter';

export default {
  actions: (actions) => actions.reduce((acc, curr) => [...acc, curr], []),
  nav: (routes) => {
    const withMarketing = insertRouteAfter(routes, 'planning', {
      i18n_value: 'admin_relational_marketing',
      path: '/marketing?view=list',
      permission: 'hyp.marketing.list',
      active_paths: ['/marketing'],
      feature: 'campaigns',
    });
    // eslint-disable-next-line camelcase
    const statPage = withMarketing.find(({ i18n_value }) => i18n_value === 'statistics');
    const withStatsMarketing = insertRouteAfter(statPage.children, 'admin_campaigns', {
      i18n_value: 'admin_relational_marketing',
      path: '/statistics/marketing',
      permission: 'hyp.marketing.manage',
      feature: 'campaigns',
    });
    statPage.children = withStatsMarketing;

    return withMarketing;
  },
  admin: (routes) =>
    insertRouteAfter(routes, 'admin_campaigns', {
      i18n_value: 'admin_relational_marketing',
      feature: 'campaigns',
      path: '/admin/marketing',
      permission: 'hyp.marketing.manage',
      children: [
        {
          i18n_value: 'admin_list',
          feature: 'campaigns',
          path: '/admin/marketing',
          permission: 'hyp.marketing.manage',
        },
        {
          i18n_value: 'admin_category',
          feature: 'campaigns',
          path: '/admin/marketing/categories',
          permission: 'hyp.marketing.manage',
        },
      ],
    }),
};
